/**
 * woocommerce.js
 */

// Import
import "./woocommerce.scss";
import $ from 'jquery';

$(document).ready(function() {

});